import { memo } from "react";
import { Link } from "react-router-dom";
import RLCard from "../../../../../../components/card/RLCard";
import { settings } from "../../../../../../shim/jsbridge";
import RelationshipGraphRSContainer from "../../../../../relationship-graph/components/RelationshipGraphRSContainer";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import styles from "../../../../containers/report_summary/report-summary.module.scss";
import { useLocalSampleSummaryParams } from "../../../../hooks";
import { pathToSS } from "../../../../util";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { Tooltip } from "../common";

const GRAPH_PATH = "/graph/new";

const SimpleRelationshipsGraphCard = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const graphExplorerPath = hash ? `${GRAPH_PATH}?hash=${hash}` : GRAPH_PATH;
  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              message={DESCRIPTIONS[COMPONENT_IDS.RELATIONSHIP_GRAPH]}
              placement="top"
            >
              <span>Relationship Graph</span>
            </Tooltip>
          }
          LinkComponent={
            <Link
              className={styles.link}
              to={
                settings.FEATURE_GRAPH_EXPLORER
                  ? graphExplorerPath
                  : pathToSS(
                      hash,
                      sourceId,
                      SECTIONS.FILE_ANALYSIS.RELATIONSHIPS_GRAPH,
                      relationshipId
                    )
              }
              state={{ hash }}
              data-testid="report_summary_relationship_graph_card_header_link"
            >
              Explore Relationship Graph
            </Link>
          }
        />
      }
      content={
        <RLCard.Content>
          <RelationshipGraphRSContainer />
        </RLCard.Content>
      }
      data-testid="report_summary_sample_relationships_card"
    />
  );
};
export default memo(SimpleRelationshipsGraphCard);
